import styled from "styled-components";

import { Align, FLEX_ALIGN, Space, SPACE } from "../LayoutTokens";

export const StyledStack = styled.div<{ $space: Space; $align?: Align }>`
  display: flex;
  flex-direction: column;
  gap: ${({ $space }) => SPACE[$space]};
  ${({ $align }) => ($align ? `align-items: ${FLEX_ALIGN[$align]};` : "")}
`;

StyledStack.displayName = "StyledStack";
